<template>
  <CFooter>
    <div>
      <span class="ml-1">&copy; {{getCurrentYear()}}</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Разработка</span>
      <a href="https://arbat07.ru/" target="_blank">Фотостудия «Арбат»</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheProfileFooter',
  methods: {
    getCurrentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>
